"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'search';
exports.SEARCH = exports.namespace + "/SEARCH";
exports.SET_SEARCH_QUERY = exports.namespace + "/SET_SEARCH_QUERY";
exports.SUGGESTIONS = exports.namespace + "/SUGGESTIONS";
exports.FETCH_POPULAR = exports.namespace + "/FETCH_POPULAR";
exports.FETCH_SIMILAR = exports.namespace + "/FETCH_SIMILAR";
//# sourceMappingURL=constants.js.map